import { render, staticRenderFns } from "./assessment-new.vue?vue&type=template&id=64ba3fbf&scoped=true&"
import script from "./assessment-new.vue?vue&type=script&lang=js&"
export * from "./assessment-new.vue?vue&type=script&lang=js&"
import style0 from "./assessment-new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./assessment-new.vue?vue&type=style&index=1&id=64ba3fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba3fbf",
  null
  
)

export default component.exports